import React from 'react';
import classNames from 'classnames';
import styles from './loader.scss';

const Loader = () =>
  <div className={styles.container}>
    <span className={classNames(styles.dot, 'forum-text-background-color')}/>
    <span className={classNames(styles.dot, 'forum-text-background-color')}/>
    <span className={classNames(styles.dot, 'forum-text-background-color')}/>
  </div>;

export default Loader;



// WEBPACK FOOTER //
// ./app/components/loader/loader.js